import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * DeleteIcon - A horizontal line icon used for delete/remove actions
 */
export const DeleteIcon = ({ size = 16, color = "#4B5563", className = "", ...props }) => {
    return (_jsx(Icon, { size: size, color: color, viewBox: "0 0 16 16", className: className, ...props, children: _jsx("path", { d: "M2 8H14", stroke: color, strokeWidth: "1.5", strokeLinecap: "round" }) }));
};
